import styled from "styled-components";
import theme from "../../../../../theme";

export const DEFAULT_COLORS = [
  "rgb(30, 34, 255)",
  "rgb(99, 102, 255)",
  "rgb(145, 148, 255)",
  "rgb(174, 176, 255)",
  "rgb(210, 211, 255)"
];

const CHANNEL_SELECTED_COLORS = ["#95959D", "#95959dd1", "#95959da8", "#95959d96", "#95959d6e"];
const CHANNEL_SELECTED_BIGGER_COLOR = "rgb(30, 34, 255)";

export const selectColorPalette = (index, metric, selectedChannel) => {
  if (selectedChannel && metric.name === selectedChannel) {
    return CHANNEL_SELECTED_BIGGER_COLOR;
  }

  if (selectedChannel && metric.name !== selectedChannel) {
    return CHANNEL_SELECTED_COLORS[index % DEFAULT_COLORS.length];
  }

  return DEFAULT_COLORS[index % DEFAULT_COLORS.length];
};

export const PercentageLabel = {
  fontSize: 12,
  color: theme.colors.dataViz.primaryPercentageColor
};

export const PieChartWrapper = styled.div`
  display: flex;
  gap: 4px;
  flex-direction: column;
  font-size: 11px;
  text-align: center;
  color: ${({ theme }) => theme.colors.dataViz.lightPercentageColor};
`;

export const PieContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;

  height: 300px;
  border: 1px solid rgb(241, 234, 234);
  border-radius: 5px;
  font-family: "Rubik";

  div:first-child {
    width: ${({ pieWidth }) => pieWidth}px !important;
  }

  @media print {
    break-inside: avoid;
    page-break-inside: avoid;
  }

  ${({ styling }) => styling}
`;

export const TooltipBox = styled.div`
  padding: 12px;
  color: #ffffff;
  background-color: #222222;
  border-radius: 4px;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  gap: 4px;

  > strong {
    margin-bottom: 4px;
  }
`;

export const ChartWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 40px;
  max-width: 900px;
  width: 100%;
`;

export const LegendWrapper = styled.div`
  min-width: 150px;
`;
